// @flow

import { List } from "immutable"
import Cookies from "js-cookie"
import type { AuthUser } from "@kiwicom/nitro/lib/records/Auth"

import { EXPIRY_DAYS, UA_SESSION_TOKEN } from "../../../consts/auth"
import { LOGIN_SUCCESS, LOGOUT_SUCCESS } from "../../../services/user"
import authStore from "../../../services/user/authStore"
import User from "../../../records/User"
import Balance from "../../../records/Balance"

export default (userInfo: AuthUser) => (dispatch: Dispatch<*>) => {
  const user = new User({
    ...userInfo.user,
    token: userInfo.token,
    balances: new List(userInfo.user.balances || []).map(
      balance => new Balance({ ...balance, amount: Number(balance.amount) }),
    ),
  })

  authStore.token = userInfo.token
  Cookies.set(UA_SESSION_TOKEN, userInfo.token, {
    ...Skypicker.cookieOptions,
    expires: EXPIRY_DAYS,
  })

  dispatch({ type: LOGOUT_SUCCESS })
  dispatch({ type: LOGIN_SUCCESS, res: user })
}
